// extracted by mini-css-extract-plugin
export var animationContainer = "_ic-0";
export var footer = "_ic-1";
export var gray = "_ic-2";
export var lineItem = "_ic-3";
export var lineItemImage = "_ic-4";
export var lineItemInfo = "_ic-5";
export var lineItemText = "_ic-6";
export var lineItems = "_ic-7";
export var modalContent = "_ic-8";
export var options = "_ic-9";
export var orderName = "_ic-a";
export var refundAmount = "_ic-b";